
const digest = '2a2c889cdc5c4ecf34e444380eb20e318d0371cc144c430acb6cadc242b37cce';
const classes = {"wrapper":"_wrapper_182hh_1","inputs":"_inputs_182hh_6","tooltipWrapper":"_tooltipWrapper_182hh_9"};
const css = `._wrapper_182hh_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_182hh_1 ._inputs_182hh_6 {
  flex: 1;
}
._wrapper_182hh_1 ._tooltipWrapper_182hh_9 {
  padding-top: 41px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  